module.exports = __webpack_public_path__ + "img/xuanxing_banner_pt.027f2cde.jpg";